import styles from './ToggleSwitchCheckbox.module.css';
import { ReactComponent as InfoIcon } from '../../../assets/images/info-icon.svg';

interface ToggleSwitch {
  value: Boolean,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  labelText: string,
  description?: string,
  disabled?: boolean,
  infoText?: string | null
}

const ToggleSwitchCheckbox = ({ value, onChange, labelText, description, disabled, infoText }: ToggleSwitch) => {
  return (
    <div>
      <div className={styles.labelText}>
        {labelText}
        {infoText ? (<span data-tip={infoText} data-for="input-tooltip" className="cursor-help">
          <InfoIcon className='text-light-blue' /></span>)
          : null}
      </div>
      <div className={disabled ? styles.toggleSwitchContainerDisabled : ''}>
        {description ? <div className={styles.descText}>{description}</div> : null}
        <label className={styles.toggleSwitch}>
          <input type="checkbox" className={styles.checkbox} checked={!!value} onChange={onChange} disabled={disabled} />
          <span className={styles.knob}></span>
          <span className={`${styles.statusText} ${styles.checkedText}`}>Yes</span>
          <span className={`${styles.statusText} ${styles.unCheckedText}`}>No</span>
        </label>
      </div>
    </div>
  )
}

export default ToggleSwitchCheckbox;